export default __webpack_public_path__ + "static/media/google.4de205d8.svg";